import React from 'react';
import Home from '../pages/Home';
import ProjectsList from '../pages/ProjectsList';
import ReportPage from '../pages/ReportPage';
import Login from '../components/user-management/Login';
// import generateReport from '../components/report/ReportGeneration';
import { ROUTES } from './constants/urls';
import DivisionUpload from '../components/DivisionUpload';
import ReportsList from '../pages/ReportsList';
// import ReportGeneration from '../components/report/ReportGeneration';
import LineItemsList from '../pages/LineItemsList';
import Comp from 'pages/Comp';
import ForgotPassword from '../components/user-management/ForgotPassword';
import ResetPassword from '../components/user-management/ResetPassword';
import CCReportsList from 'pages/CCReportsList';
import CCReport from 'pages/CCReport';
import QCCReportsList from 'pages/QCCReportsList';
import QCCReport from 'pages/QCCReport';
import Project from 'pages/Project';
import ProjectVersions from 'pages/ProjectVersions';
import PayappProcess from 'pages/PayappProcess';
import LimitedReportWizardPage from 'pages/LimitedReportWizardPage';
import MagicReportWizardPage from 'pages/MagicReportWizardPage';
import CostAnalysisInvoicePage from 'pages/CostAnalysisInvoicePage';
import CCReportInvoicePage from 'pages/CCReportInvoicePage';
import UsersList from 'pages/UsersList';
import UserProfilePage from 'pages/UserProfilePage';
import { ACTION_ROLES } from '../constants/ActionRoles';

const AppRoutes: {
  index?: boolean;
  path: string;
  name: string;
  pageHeader?: string;
  element: JSX.Element;
  icon?: string;
  isPrivate?: boolean;
  showSidenav?: boolean;
  showNavbar?: boolean;
  requiredRoles?: string[];
}[] = [
  {
    index: true,
    path: ROUTES.HOME,
    name: 'Home',
    element: <Home />,
    icon: 'home',
    pageHeader: 'Dashboard',
    isPrivate: true,
  },
  {
    path: ROUTES.LOGIN,
    name: 'Login',
    element: <Login />,
    isPrivate: false,
    showSidenav: false, // Added flag to hide the sidenav
    showNavbar: false, // Added flag to hide the navbar
  },
  {
    path: ROUTES.FORGOTPASSWORD, // Define the login route
    name: 'ForgotPassword',
    element: <ForgotPassword />,
    isPrivate: false, // Login should be accessible to unauthenticated users
    showSidenav: false, // Added flag to hide the sidenav
    showNavbar: true, // Added flag to hide the navbar
  },
  {
    path: '/reset-password',
    name: 'Reset Password',
    element: <ResetPassword />,
    isPrivate: false,
    showSidenav: false,
    showNavbar: false,
  },
  {
    path: ROUTES.PROJECTS,
    name: 'Projects',
    element: <ProjectsList />,
    icon: 'description',
    pageHeader: 'Projects',
    isPrivate: true,
  },
  {
    path: `${ROUTES.PROJECTS}/:projectId`,
    name: 'Project',
    element: <Project />,
    isPrivate: true,
  },
  {
    path: `${ROUTES.PROJECTS}/:projectId${ROUTES.LIMITED_REPORT}/:reportId/:stepId?`,
    name: 'Limited Report',
    element: <LimitedReportWizardPage />,
    isPrivate: true,
  },
  {
    path: `${ROUTES.PROJECTS}/:projectId${ROUTES.MAGIC_REPORT}/:reportId/:stepId?`,
    name: 'Magic Report',
    element: <MagicReportWizardPage />,
    isPrivate: true,
  },
  {
    path: `${ROUTES.PROJECT_VERSIONS}/:projectId`,
    name: 'Project Versions',
    element: <ProjectVersions />,
    isPrivate: true,
  },
  {
    path: ROUTES.CA_REPORTS,
    name: 'Cost Analysis',
    element: <ReportsList />,
    icon: 'assessment',
    pageHeader: 'Cost Analysis Reports',
    isPrivate: true,
  },
  {
    path: `${ROUTES.CA_REPORTS}/:reportId`,
    name: 'Report',
    pageHeader: 'Cost Analysis Report',
    element: <ReportPage />,
    isPrivate: true,
  },
  {
    path: `${ROUTES.CA_REPORTS}/:reportId/invoice`,
    name: 'Invoice',
    pageHeader: 'Export Invoice',
    element: <CostAnalysisInvoicePage />,
    isPrivate: true,
  },
  {
    path: ROUTES.CC_REPORTS,
    name: 'Construction Cost',
    element: <CCReportsList />,
    icon: 'stacked_bar_chart',
    pageHeader: 'Construction Cost Reports',
    isPrivate: true,
  },
  {
    path: `${ROUTES.CC_REPORTS}/:reportId`,
    name: 'Report',
    pageHeader: 'Construction Cost Report',
    element: <CCReport />,
    isPrivate: true,
  },
  {
    path: `${ROUTES.CC_REPORTS}/:reportId/invoice`,
    name: 'Invoice',
    pageHeader: 'Export Invoice',
    element: <CCReportInvoicePage />,
    isPrivate: true,
  },
  {
    path: ROUTES.QCC_REPORTS,
    name: 'Quarterly Cost',
    element: <QCCReportsList />,
    icon: 'pie_chart',
    pageHeader: 'Quarterly Cost Reports',
    isPrivate: true,
  },
  {
    path: `${ROUTES.QCC_REPORTS}/:reportId`,
    name: 'Report',
    pageHeader: 'Quarterly Cost Report',
    element: <QCCReport />,
    isPrivate: true,
  },
  {
    path: ROUTES.LINEITEMS,
    name: 'Division Mapping',
    element: <LineItemsList />,
    icon: 'list',
    pageHeader: 'Division Mapping',
    isPrivate: true,
  },
  {
    path: ROUTES.GENERATE_REPORT,
    name: 'Generate Report',
    element: <ReportPage />,
    isPrivate: true,
  },
  {
    path: `${ROUTES.COMPS}/:compId`,
    name: 'Comparable',
    element: <Comp />,
    isPrivate: true,
  },
  {
    path: `${ROUTES.UPLOADTODB}`,
    name: 'Upload to DB',
    element: <DivisionUpload />,
    isPrivate: true,
  },
  {
    path: `${ROUTES.PROJECTS}/:projectId${ROUTES.PROCESSPAYAPP}/:payappDrawId/:stepId?`,
    name: 'Process payapp',
    element: <PayappProcess />,
    isPrivate: true,
  },
  {
    path: ROUTES.USER_PROFILE,
    name: 'Profile',
    element: <UserProfilePage />,
    icon: 'person',
    pageHeader: 'User Profile',
    isPrivate: true,
  },
  {
    path: ROUTES.USERS,
    name: 'Users',
    element: <UsersList />,
    icon: 'people',
    pageHeader: 'User Management',
    isPrivate: true,
    requiredRoles: ACTION_ROLES.MANAGE_USERS,
  },
];

export default AppRoutes;
